// @flow
import React from 'react';
import { Wrapper, Container } from './styles';
import Image from '@components/Image';

const ImageWrapper = ({ image }) => (
  <Container>
    <Wrapper>
      <Image src={image.file.url} />
    </Wrapper>
  </Container>
);

export default ImageWrapper;
